<template>
  <div class="w-100 h-100">
    <dv-border-box-7>
      <div class="h-100">
        <zd-scroll-pic @click="clickRow($event)" :config="config" />
      </div>
      <div class="tooltip-container">
        <el-tooltip effect="dark" content="最近一天的数据，按检验日期查询" placement="top-start">
          <i class="el-icon-question" style="font-size:16px;"></i>
        </el-tooltip>
      </div>
    </dv-border-box-7>
    <!--问题详情-->
    <el-dialog :title="'图片列表'" :visible.sync="imgDialog" width="60%" center>
      <div style="text-align:center;height:80vh;z-index: 999;">
        <el-carousel indicator-position="outside" style="height:80vh">
          <el-carousel-item style="height: 80vh;" v-for="item in imgs" :key="item.idx + item.src">
            <div style="position: relative;">
              <div style="z-index:999;line-height:23px;position: absolute;left:0;padding:5px 12px;background:#018DCE">{{ item.idx }}
              </div>
              <el-image :src='item.src' :fit="'fill'"></el-image>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dateFormat from "date-fns/format";
import { af, be } from "date-fns/locale";
export default {
  name: "defect-img",
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      imgs: [],
      imgDialog: false,
      startCharts: null,
      dataList: this.beans,
      config: {
        headerHeight:20,
        carousel: 'page',
        startCharts: "",
        header: ["缺陷图片"],
        rowNum: 2,
        columnWidth: [500],

        data: [],
      },
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.dataList = val;
        var data = [];
        let result = this.dataList;
        var imgs = [];
        for (var i = 0; i < result.length; i++) {
          var beforeImg = result[i];
          var idx = null;
          //这里为啥要截断，因为返回的是base64格式的字符串，前两个字符是加了下标,data:image/png;base64,
          if (beforeImg) {
            idx = beforeImg[0];
            beforeImg = beforeImg.substr(2, beforeImg.length);
          }
          imgs.push({ 'idx': idx, 'src': beforeImg });
          var before = "<div style='width:100%;height:100%;position:relative;'><div style='line-height:23px;position: absolute;left:0;padding:5px 12px;background:#F25346'>" + (idx) + "</div><img style='height: 100%;background-size: cover;background-repeat: no-repeat center ;' src=" + beforeImg + " ></div>";
          var value = [before];
          data.push(value);
        }
        this.imgs = imgs;
        this.config = {
          // headerBGC:'#fff',
          carousel: 'page',
          headerHeight: 30,
          waitTime: 5000,
          startCharts: "",
		      headerBGC: "#018DCE",
          header: ['<span style="color:#fff;font-size:0.25rem">缺陷图片</span>'],
          rowNum: 1,
          columnWidth: [],
          align: ['center', 'center'],
          data: data,
        };
      },
      deep: true,
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    dateFormat(uninx) {
      return dateFormat(uninx, "MM/dd");
    },
    clickRow($event) {
      this.imgDialog = true;
    }
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>

<style scoped>
.tooltip-container {
  right: 0;
  bottom: 0;
  position: absolute;
  z-index: auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/nok/component/defect-img-list.vue